import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { formatToINR } from "../../../../helpers/utility";
import admissionIcon from "../../../../assets/receptionistIcons/ipBilling/admission.svg";
import statusIcon from "../../../../assets/receptionistIcons/ipBilling/status.svg";
import billAmountIcon from "../../../../assets/receptionistIcons/ipBilling/billAmount.svg";
import balanceIcon from "../../../../assets/receptionistIcons/ipBilling/balance.svg";
import styles from "./BillingIp.module.css";

dayjs.extend(relativeTime);

const SummaryCard = ({ icon, label, value, sub, valueClassName = "" }) => (
  <article className={styles.summaryCard}>
    <img src={icon} alt="" className={styles.summaryIcon} />
    <div className={styles.summaryContent}>
      <p className={styles.summaryLabel}>{label}</p>
      <p className={`${styles.summaryValue} ${valueClassName}`.trim()}>{value}</p>
      {sub ? <p className={styles.summarySub}>{sub}</p> : null}
    </div>
  </article>
);

const BillingSummaryCards = ({ cardData }) => {
  const admissionDate = cardData?.beds_details?.initial_bed_time;
  const activeBed = cardData?.beds_details?.beds?.find((b) => b.status === "active");
  const roomLabel = activeBed
    ? `Room ${activeBed.room_no} · ${activeBed.room_type || "—"}`
    : "—";

  const balance = cardData?.payment_details?.total_due_amount || 0;

  const renderBalanceValue = () => {
    if (balance * -1 < 0) {
      return {
        text: formatToINR(balance * -1),
        className: styles.summaryValueDue,
      };
    }
    if (balance * -1 > 0) {
      return {
        text: `+${formatToINR(balance * -1) || 0}`,
        className: styles.summaryValueCredit,
      };
    }
    return {
      text: formatToINR(balance) || "₹0",
      className: "",
    };
  };

  const balanceDisplay = renderBalanceValue();

  return (
    <div className={styles.summaryRow}>
      <div className={styles.summaryMergedCard}>
        <SummaryCard
          icon={admissionIcon}
          label="Date of admission"
          value={admissionDate ? dayjs(admissionDate).format("D MMM YYYY") : "—"}
          sub={
            admissionDate
              ? `${dayjs(admissionDate).format("HH:mm")} · ${dayjs(admissionDate).fromNow()}`
              : "—"
          }
        />

        <SummaryCard
          icon={statusIcon}
          label="Status"
          value={
            cardData?.admission?.is_active
              ? "Active"
              : dayjs(cardData?.admission?.discharge_date).format("D MMM YYYY")
          }
          sub={cardData?.admission?.is_active ? roomLabel : "Discharged"}
          valueClassName={
            cardData?.admission?.is_active ? styles.summaryValueActive : ""
          }
        />
      </div>

      <div className={styles.summaryMergedCard}>
        <SummaryCard
          icon={billAmountIcon}
          label="Bill amount"
          value={formatToINR(cardData?.payment_details?.total_amount)}
          sub="Inclusive of bed + services"
        />

        <SummaryCard
          icon={balanceIcon}
          label="Balance amount"
          value={balanceDisplay.text}
          sub="Balance with patient"
          valueClassName={balanceDisplay.className}
        />
      </div>
    </div>
  );
};

export default BillingSummaryCards;
